import { render, staticRenderFns } from "./ReceivedContactLists.vue?vue&type=template&id=c82f8ce2&scoped=true&"
import script from "./ReceivedContactLists.vue?vue&type=script&lang=js&"
export * from "./ReceivedContactLists.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedContactLists.vue?vue&type=style&index=0&id=c82f8ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82f8ce2",
  null
  
)

export default component.exports